import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { resolveImageUrl } from "../../lib/SettingsContext";

export default function Testimonials({ items }) {
  return (
    <section className="py-24 bg-white">
      <div className="container-x">
        <div className="max-w-2xl">
          <div className="overline text-brand-green">Testimonials</div>
          <h2 className="mt-3 font-display text-4xl sm:text-5xl font-extrabold text-brand-ink leading-tight tracking-tight">
            Loved by businesses who <span className="text-brand-blue">care about brand.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((t, i) => {
            const avatar = resolveImageUrl(t.avatar_url);
            return (
              <motion.div
                key={t.id}
                initial={{ opacity: 0, y: 18 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                data-testid={`testimonial-card-${i}`}
                className="card-surface p-7 relative"
              >
                <Quote className="h-8 w-8 text-brand-green/30 absolute top-5 right-5" />
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Star key={k} className="h-4 w-4 fill-brand-green text-brand-green" />
                  ))}
                </div>
                <p className="mt-4 text-gray-700 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
                <div className="mt-6 pt-5 border-t border-gray-100 flex items-center gap-3">
                  {avatar ? (
                    <img src={avatar} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-1 ring-gray-200" />
                  ) : (
                    <div className="h-11 w-11 rounded-full bg-brand-blue/10 text-brand-blue grid place-items-center font-display font-bold">
                      {(t.name || "?").charAt(0).toUpperCase()}
                    </div>
                  )}
                  <div>
                    <div className="font-display font-bold text-brand-ink">{t.name}</div>
                    <div className="text-xs text-gray-500 mt-0.5">{t.role}</div>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
